import BoldLargeText from '@/components/BoldLargeText';
import GridLayoutPreview from '@/components/GridLayoutPreview';
import Preview from '@/components/Preview';
import RegularText from '@/components/RegularText';
import { stickyTopCreateCheckoutRule, stickyTopOnboarding } from '@/constants';
import onboardingSlice, { onboardingSelector } from '@/redux/slice/onboarding.slice';
import { locationInfoSelector } from '@/redux/slice/settings.slice';
import { Button, InlineError } from '@shopify/polaris';
import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IProps, RuleTypeEnum } from '.';
import EditRule from './components/EditRule';
import EditCheckoutRule from '@/pages/Onboarding/components/EditCheckoutRule';
import PreviewCheckout from '@/components/Preview/PreviewCheckout';
import PreviewThankyouOrder from '@/components/Preview/PreviewThankyouOrder';
import { ThankyouDisplayModes } from '@/constants/enum';

const Step3 = (props: IProps) => {
  const dispatch = useDispatch();
  const onboarding = useSelector(onboardingSelector);
  const locationInfo = useSelector(locationInfoSelector);

  return (
    <div className="step-3">
      <div className="d-flex flex-column gap-12 items-center">
        <BoldLargeText alignment="center">Set up a rule</BoldLargeText>
        <RegularText alignment="center">Start with the essentials. There are more customizations later in app</RegularText>
        <>
          <div className="button-group">
            <Button variant="tertiary" onClick={props.handleFinish}>
              Skip
            </Button>
            <Button variant="primary" disabled={props.isDisabled} onClick={props.handleNext}>
              Save and continue
            </Button>
          </div>
          {props.isShowError ? (
            <div className="save-rules-error mb-8">
              <InlineError
                fieldID="method"
                message={'Changes have been saved and cannot be undone. You can edit later in app.'}
              />
            </div>
          ) : null}
        </>
      </div>
      {props.ruleType === RuleTypeEnum.Checkout ? (
        <GridLayoutPreview>
          <div>
            <EditCheckoutRule />
          </div>
          <div className="d-flex flex-column gap-12">
            <PreviewCheckout top={stickyTopCreateCheckoutRule} dataCheckout={onboarding.checkoutRule} />
            <PreviewThankyouOrder displayMode={ThankyouDisplayModes.banner} top={stickyTopCreateCheckoutRule} isInOnboarding />
          </div>
        </GridLayoutPreview>
      ) : (
        <GridLayoutPreview>
          <div>
            <EditRule
              state={onboarding.rule}
              setState={(key, value) => {
                dispatch(onboardingSlice.actions.handleChangeRule({ key, value }));
              }}
            />
          </div>
          <div>
            <Preview
              top={stickyTopOnboarding}
              defaultData={onboarding.rule}
              isInSmallPage
              zipcodePlaceholder={`Try ${locationInfo?.data?.zip_code || '00501'}`}
              isAutoDetect={true}
              isShowRuleStatus={false}
            />
          </div>
        </GridLayoutPreview>
      )}
    </div>
  );
};

export default memo(Step3);
